import { getUrlByTargetContent, logNative } from '../../utils/utils'

export default function generateURL(info = {}) {
  // 跳转外部链接
  if (info.targetType === '2') {
    if (info.targetUrl) {
      return {
        external: true,
        url: info.targetUrl,
      }
    }

    if (info.targetContent) {
      try {
        const { targetUrl } = JSON.parse(info.targetContent);
        if (!targetUrl) throw new Error('targetUrl does not exist');
        return {
          external: true,
          url: targetUrl,
        }
      } catch (e) {
        logNative(`分析URL generateURL JSON解析错误:${e}`, e);
      }
    }
  }

  // 跳转外部链接（定义的ADX广告）
  if (info.targetType === '10') {
    if (info.advertUrl) {
      return {
        external: true,
        url: info.advertUrl,
      }
    }

    if (info.targetContent) {
      try {
        const { advertUrl } = JSON.parse(info.targetContent);
        if (!advertUrl) throw new Error('advertUrl does not exist');
        return {
          external: true,
          url: advertUrl,
        }
      } catch (e) {
        logNative(`分析URL generateURL JSON解析错误:${e}`, e);
      }
    }
  }

  // 跳商品购买弹窗
  if (info.targetType === '5' && info.targetContent) {
    try {
      const { url } = JSON.parse(info.targetContent);
      if (!url) throw new Error('url does not exist');
      return {
        pay: true,
        url,
      }
    } catch (e) {
      logNative(`分析URL generateURL JSON解析错误:${e}`, e);
    }
  }

  return {url: getUrlByTargetContent(info)}
}
